import { v4 as uuid } from 'uuid';
import { UUIDv4 } from '@quality24/inpatient-typings';
import {
  ComposedReleasedSurvey,
  HookSurveyAnswer,
  HookSurveyPage,
} from './types';

/**
 * Map each page to an answer
 */
export const initAnswers = ({
  id,
  pages,
}: ComposedReleasedSurvey): Array<HookSurveyAnswer> =>
  pages.map((page) => ({
    id: uuid() as UUIDv4,
    releasedSurveyId: id,
    questionId: page.id,
    value: {
      score: undefined,
      smileyScore: undefined,
      improvements: undefined,
      text: '',
    },
    // The survey_answer.data column mirrors the page config and is NOT NULL
    data: page.data,
    // Page data
    category: page.category,
    type: page.type,
  }));

/**
 * Check if the given page is properly answered.
 */
export const checkCanNext = (
  page: HookSurveyPage,
  answer: HookSurveyAnswer,
) => {
  const isMissingAnswer =
    (!!page.required || !!page.data.required) &&
    answer.value.score === undefined &&
    answer.value.smileyScore === undefined;

  const isMissingComment =
    !!page.data.commentOptions?.required && !answer.value.text;

  return !isMissingAnswer && !isMissingComment;
};
